import { useMemo } from 'react'
import { IntentId, NlpModel } from '@feedyou-ai/feedbot-schema'

import { useNlpModels } from '../../../store/flow'
import { getModelForIntentId } from '../../nlp/TrainingTab/components/TrainingTab/components/implementations/NlpModel/utils'

export function useNlpModelForIntentId(intentId: IntentId): NlpModel | undefined {
  const models = useNlpModels()
  return useMemo(() => getModelForIntentId(intentId, models), [models, intentId])
}
